// src/components/CheckoutForm.tsx

import React from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { Dialog } from "primereact/dialog";
import { Ripple } from "primereact/ripple";
import { Button } from "primereact/button";
import CheckoutFormInner from "./CheckoutFormInner";
import { PaymentIntent } from "@stripe/stripe-js";

const stripePromise = loadStripe(
  "pk_test_51POtSiIPpmakyoBd7356yA5XQY8ABp8877UI1dpSA0Iku8eMZmtgr9WtOexWpvkulCSl4rCv30SCR0nH0vLvwPtF00HtkjX9d5"
);

interface StripePaymentGateWayAction {
  isOpen: boolean;
  onClose: () => void;
  amount: number;
  onPaymentSuccess: (paymentIntent: PaymentIntent | undefined) => void;
}

const CheckoutForm: React.FC<StripePaymentGateWayAction> = ({
  isOpen,
  onClose,
  amount,
  onPaymentSuccess
}) => {
  const modalHeader = (
    <div className="custom_modal_header_inner">
      <h5 className="modal-title fs-5">
        Payment
      </h5>
      <button type="button" className="close_modal_btn p-ripple"
        onClick={onClose}>
        <i className="bi bi-x-circle"></i>
        <Ripple />
      </button>
    </div>
  );

  return (
    <Dialog
      visible={isOpen}
      header={modalHeader}
      headerClassName="custom_modal_header"
      className="custom_modal_dialog modal_dialog_sm"
      onHide={onClose}
      draggable={false}
      resizable={false}
      dismissableMask
    >
      <div className="custom_modal_body">
        <div className="pt-1 pt-sm-0 pb-1 pb-sm-0 w-100">
          <Elements stripe={stripePromise}>
            <CheckoutFormInner
              amount={amount}
              onClose={onClose}
              onPaymentComplete={onPaymentSuccess}
            />
          </Elements>
        </div>
      </div>
    </Dialog>
  );
};

export default CheckoutForm;
